<div class="view-container">
  <div class="company-finish">
    <h2>
      <T
        str="We received your request"
        key="customerPortal.kc.company-finish.title"
        tags="kc-forms, 3.1"
      >
      </T>
    </h2>
    <!-- prettier-ignore -->
    <p [innerHTML]="getTranslation()"></p>
    <button
      mat-button
      mat-flat-button
      color="primary"
      (click)="submit()"
      [disabled]="submitting"
    >
      <T
        str="Finish"
        key="customerPortal.kc.company-finish.button"
        tags="kc-forms, 3.1"
      >
      </T>
    </button>
    <form #activationFinishForm method="POST">
      <input type="hidden" name="step" value="finish" />
    </form>
  </div>
</div>
